<template lang="pug">
div
  PlanCards
  PlansTable
  HowMuch
</template>

<script>
export default {
  name: 'Enterprise',
  components: {
    PlanCards: () => import('../components/plans/PlanCards'),
    PlansTable: () => import('../components/plans/PlansTable'),
    HowMuch: () => import('../components/plans/HowMuch')
  }
}
</script>

<style lang="sass"></style>
